import { h, JSX } from 'preact'
import cx from 'classnames'
import {
  nrkArrowLeft,
  nrkArrowRight,
  nrkChevronDown,
  nrkChevronUp,
  nrkCheck,
  nrkSearch,
  nrkClose,
  nrkPoll,
  nrkReload
} from '@nrk/core-icons'
import endring from './assets/Endring.svg?inline-renamed'
import overblikk from './assets/Overblikk.svg?inline-renamed'
import detaljert from './assets/Detaljert.svg?inline-renamed'
import stemmer from './assets/Stemmer.svg?inline-renamed'
import kalender from './assets/Kalender.svg?inline-renamed'

import styles from './Icons.module.css'

export type IconType =
  | 'info'
  | 'tab-endring'
  | 'tab-overblikk'
  | 'tab-detaljert'
  | 'tab-stemmer'
  | 'tab-kalender'
  | 'nrk-arrow-left'
  | 'nrk-arrow-right'
  | 'nrk-chevron-down'
  | 'nrk-chevron-up'
  | 'nrk-check'
  | 'nrk-reload'
  | 'nrk-search'
  | 'nrk-close'
  | 'nrk-poll'
  | 'valg-bars'
  | 'valg-arrow-up'
  | 'valg-arrow-down'
  | 'MISSING'

interface IconProps extends JSX.HTMLAttributes {
  color?: string
  type: IconType
}

export function Icon({ type, color, class: cName, className, ...rest }: IconProps) {
  const icon = getIcon(type, color)
  const classes = cx(styles.icon, cName, className)

  if (typeof icon === 'string') {
    return <span class={classes} dangerouslySetInnerHTML={{ __html: icon }} {...rest} />
  }
  return (
    <span class={classes} {...rest}>
      {icon}
    </span>
  )
}

function getIcon(type: IconType, color?: string): string | JSX.Element {
  switch (type) {
    case 'info':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 31" width="1.5em" height="1.5em">
          <g fill="none" fill-rule="evenodd">
            <circle cx="15" cy="15" r="15" fill="#FA6C00" />
            <path
              fill="#FFF"
              fill-rule="nonzero"
              stroke="#FFF"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 6.2c-.7 0-1.2.4-1.2 1.1 0 .6.5 1 1.2 1 .6 0 1.1-.4 1.1-1s-.5-1-1.1-1zm.9 5.2h-3.1v1l1.5.5v8.7l-1.5.4v1h4.6v-1l-1.5-.4V11.4z"
            />
          </g>
        </svg>
      )
    case 'valg-arrow-up':
      return (
        <svg
          width="1.5em"
          height="1.5em"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke={color || '#3D8704'} stroke-width="2" fill="none">
            <path d="M1,13 C5.83333333,13 8.91666667,10.3333333 10.25,5" />
            <polyline points="6 6 11 4 13 9" />
          </g>
        </svg>
      )
    case 'valg-arrow-down':
      return (
        <svg
          width="1.5em"
          height="1.5em"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke={color || '#E51C30'} stroke-width="2" fill="none">
            <polyline points="13 7 11 12 6 10" />
            <path d="M1,3 C5.83333333,3 8.91666667,5.66666667 10.25,11" />
          </g>
        </svg>
      )
    case 'valg-bars':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 21" width="1.5em" height="1.5em">
          <g fill={color || '#AFAFAF'} fill-rule="evenodd" transform="translate(-31 -79)">
            <rect width="4" height="21" x="45" y="79" rx="1" transform="matrix(1 0 0 -1 0 179)" />
            <rect width="4" height="16" x="38" y="84" rx="1" transform="matrix(1 0 0 -1 0 184)" />
            <rect width="4" height="11" x="31" y="89" rx="1" transform="matrix(1 0 0 -1 0 189)" />
          </g>
        </svg>
      )
    case 'nrk-arrow-left':
      return nrkArrowLeft
    case 'nrk-arrow-right':
      return nrkArrowRight
    case 'nrk-chevron-down':
      return nrkChevronDown
    case 'nrk-chevron-up':
      return nrkChevronUp
    case 'nrk-check':
      return nrkCheck
    case 'nrk-reload':
      return nrkReload
    case 'nrk-search':
      return nrkSearch
    case 'nrk-close':
      return nrkClose
    case 'nrk-poll':
      return nrkPoll
    case 'tab-endring':
      return endring
    case 'tab-overblikk':
      return overblikk
    case 'tab-detaljert':
      return detaljert
    case 'tab-stemmer':
      return stemmer
    case 'tab-kalender':
      return kalender
    case 'MISSING':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 23" width="1.5em" height="1.5em">
          <path fill="none" stroke="#979797" d="M.5.5h20v22H.5z" />
        </svg>
      )
    default:
      throw Error(`Icon with type ${type} is invalid`)
  }
}
